import { Component } from '@angular/core';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ILaboratory, LABORATORY_TTL_ES } from '../../laboratory.interface';
import { LaboratoryService } from '../../laboratory.service';

@Component({
  selector: 'pg-laboratory',
  templateUrl: './laboratory.component.html'
})
export class LaboratoryComponent extends CrudTemplate implements ICrudTemplate {
  constructor(private serviceBase: LaboratoryService) {
    super(LABORATORY_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: LABORATORY_TTL_ES,
      columns: [{ header: 'Laboratorio', field: 'description' }]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: ILaboratory[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
